import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { DividendReInvestSettings } from '../entities/dividend-re-invest-settings.entity';

export const dividendReInvestActions = createActionGroup({
  source: 'DividendReInvest',
  events: {
    Decline: emptyProps(),
    Activate: props<{ amountFrom: number }>(),
    Close: emptyProps(),
    'Load Current Settings': emptyProps(),
  },
});

export const dividendReInvestApiActions = createActionGroup({
  source: 'DividendReInvest API',
  events: {
    'Decline Success': props<{ settings: DividendReInvestSettings }>(),
    'Decline Failed': props<{ error: HttpErrorResponse }>(),
    'Activate Success': props<{ settings: DividendReInvestSettings }>(),
    'Activate Failed': props<{ error: HttpErrorResponse }>(),
    'Load Current Settings Success': props<{ settings: DividendReInvestSettings }>(),
    'Load Current Settings Failed': props<{ error: HttpErrorResponse }>(),
  },
});
